export type EventTypeString = 'LOGO_EXPANDING_FINISHED';

export const eventType: EventTypeString = 'LOGO_EXPANDING_FINISHED';

export type EventType = {
  type: EventTypeString,
};

export const eventBuilder = (): EventType => ({
  type: eventType,
});
